/* src/app/modules/shared/components/column/column-spacer/column-spacer.component.scss */
app-column-spacer {
  display: contents;
}
/*# sourceMappingURL=column-spacer.component.css.map */
